export enum VERB {
  CREATE = 'create',
  DELETE = 'delete',
  LIST = 'list',
  GET = 'get',
  PATCH = 'patch',
  POST = 'post',
  UPDATE = 'update',
}

export enum RESOURCE {
  CATALOG = 'catalogs',
  CATALOG_ITEM = 'catalogitems',
  FLEET = 'fleets',
  DEVICE = 'devices',
  VULNERABILITY = 'vulnerabilities',
  DEVICE_CONSOLE = 'devices/console',
  DEVICE_APPLICATION_CONSOLE = 'devices/applications/console',
  DEVICE_APPLICATION_LIFECYCLE = 'devices/applications/lifecycle',
  DEVICE_DECOMMISSION = 'devices/decommission',
  DEVICE_RESUME = 'devices/resume',
  REPOSITORY = 'repositories',
  RESOURCE_SYNC = 'resourcesyncs',
  ENROLLMENT_REQUEST = 'enrollmentrequests',
  ENROLLMENT_REQUEST_APPROVAL = 'enrollmentrequests/approval',
  ALERTS = 'alerts',
  AUTH_PROVIDER = 'authproviders',
  IMAGE_BUILD = 'imagebuilds',
  IMAGE_BUILD_LOG = 'imagebuilds/log',
  IMAGE_BUILD_CANCEL = 'imagebuilds/cancel',
  IMAGE_BUILD_NEW_VERSION = 'imagebuilds/newversion',
  IMAGE_PROMOTION = 'imagepromotions',
  IMAGE_EXPORT = 'imageexports',
  IMAGE_EXPORT_LOG = 'imageexports/log',
  IMAGE_EXPORT_CANCEL = 'imageexports/cancel',
  IMAGE_EXPORT_DOWNLOAD = 'imageexports/download',
}
